import React, {useRef, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImage, faCreditCard, faEnvelope} from "@fortawesome/pro-solid-svg-icons";
import {Blurhash} from "react-blurhash";
import {MailItemUserThumbnailType} from "../../Types/Response/Mailboxes/Mailbox";

const MailItemThumbnail: React.FC<MailItemUserThumbnailType> = (props) => {
	const [ imageLoaded, setImageLoaded] = useState<boolean>(false);

	return (
		<div className='blur-hash-wrapper mail-item-thumbnail'>
			{props.blurHash && (
				<Blurhash
					resolutionX={256}
					resolutionY={256}
					hash={props.blurHash}
					width={'100%'}
					height={'100%'}
					style={{ opacity: imageLoaded ? 0 : 1 }}
				/>
			)}
			<img
				src={props.linkToFile ? props.linkToFile : 'http://placekitten.com/96/96'}
				alt=''
				loading="lazy"
				onLoad={() => setImageLoaded(true)}
			/>
		</div>
	);
};

const MailItemNoThumbnail = (props: any) => {
	return(
		<div className={`mail-item-thumbnail no-thumbnail`}>
			{!props.content && (
				<FontAwesomeIcon icon={faEnvelope} />
			)}
			{props.content && (
				<FontAwesomeIcon icon={faImage} />
			)}
		</div>
	)
}

const MailItemTopUpRequired = () => {
	return(
		<div className={`mail-item-thumbnail no-thumbnail needs-topup`}>
			<FontAwesomeIcon icon={faCreditCard} />
		</div>
	)
}

export default MailItemThumbnail;

export { MailItemNoThumbnail, MailItemTopUpRequired }